export const step6 = {
  paymentData: 'Pagamento da apólice',
  paymentType: 'Método de pagamento',
  directDebit: 'Débito Direto',
  ownerIBAN: 'IBAN do Tomador do Seguro',
  addBank: 'Adicionar IBAN',
  signatureLegalDocument: 'Assinatura do Documento Legal',
  signatureType: 'Tipo de Assinatura',
  digital: 'Digital',
  paper: 'Papel',
  consents: 'Consentimentos',
  documentSendMethod: 'Método de Envio da Documentação ao Cliente',
  documentSend: 'Envio de Documentação',
  deliveryPerson: 'Eu entrego pessoalmente',
  deliveryAgeas: 'A Ageas envia centralmente',
  joinDigitalDocument: 'Adesão à Documentação Digital',
  emailJoinDigitalDocument: 'E-mail para adesão à Documentação Digital',
  addIBAN: 'IBAN do Tomador do Seguro',
  report: 'RELATÓRIO COMPLETO',
  errors: {
    consents: 'Por favor preencher consentimentos obrigatórios',
    warning: 'O IBAN inserido já existe',
    invalidIban: 'Por favor introduza um valor válido para este campo',
  },
}
